// extracted by mini-css-extract-plugin
export default {"radio":"CustomRadioButton_radio__+rkn7","root":"CustomRadioButton_root__9i0j4"};